var map = {
	"./baac.svg": "7c84",
	"./bay.svg": "591d",
	"./bbl.svg": "5cd3",
	"./bcel.svg": "3ead",
	"./bnp.svg": "2ec8",
	"./boa.svg": "37cf",
	"./cacib.svg": "b1c5",
	"./cimb.svg": "dcf5",
	"./citi.svg": "1867",
	"./db.svg": "ee1f",
	"./ghb.svg": "b49e",
	"./gsb.svg": "4124",
	"./hsbc.svg": "dba3",
	"./ibank.svg": "95c9",
	"./icbc.svg": "c83d",
	"./jpm.svg": "8a1a",
	"./kbank.svg": "9a52",
	"./kkp.svg": "dd8a",
	"./ktb.svg": "9773",
	"./lhb.svg": "9a08",
	"./mb.svg": "5bb4",
	"./mega.svg": "97d1",
	"./mufg.svg": "1b35",
	"./rbs.svg": "be38",
	"./sc.svg": "2954",
	"./scb.svg": "c5c4",
	"./smbc.svg": "a331",
	"./tbank.svg": "fa69",
	"./tcrb.svg": "c34b",
	"./tisco.svg": "f175",
	"./tmb.svg": "1be6",
	"./true.svg": "dd72",
	"./ttb.svg": "58e7",
	"./uob.svg": "5567"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e152";